import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import type { WhitelistedEmail } from "../api/dto";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { Paragraph } from "../components/Paragraph";
import { useRefresh } from "../components/RefreshController";

export const DeleteWhitelistedEmailModal: FC<{ whitelistedEmail: WhitelistedEmail }> = (props) => {
  const { deleteWhitelistedEmail } = useApiCall();
  const refresh = useRefresh();
  const [email, setEmail] = useState<string>("");
  const [errors, setErrors] = useState<string[]>([]);

  const save = async () => {
    await deleteWhitelistedEmail(props.whitelistedEmail.id).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    refresh();
  };

  return (
    <>
      <Paragraph>
        Weet je zeker dat je dit email wilt verwijderen? Om te bevestigen, voer het adres{" "}
        <strong>{props.whitelistedEmail.email}</strong> in.
      </Paragraph>
      <div>
        <Input
          type={"email"}
          placeholder={"email"}
          value={email}
          onChange={setEmail}
          label={"Email"}
        />
      </div>
      <ModalFooter
        text={"Verwijderen"}
        disabled={email !== props.whitelistedEmail.email}
        icon={faTimes}
        onSubmit={save}
      />
    </>
  );
};
